import React, { useRef } from 'react'
import PracticeDetailsPrintPopup from '../../EncounterRightPortion/TemplateView/Components/PracticeDetailsPrintPopup';
import FormatPhoneNumber from '../../../../../../../utils/FormatPhoneNumber';
import { Modal, ModalBody } from "react-bootstrap";
import useCaptureDataAndGeneratePDFBrowserAPI from '../../../../../../shared/CaptureDataAndGeneratePDF/useCaptureDataAndGeneratePDFBrowserAPI';
import Loader from '../../../../../../shared/Loader/Loader';

const PrintPreviewTherapyNote = ({printoutModal, setPrintoutModal, data}) => {
    let showAddressTypeLocation = false;
    let selectedItems = { uiDesign : false } ;
    let searchParam = { EncounterDate : '' } ;
    const componentRef = useRef(null);
    const { isLoading: isLoadingPdf, captureDataAndGeneratePDF } = useCaptureDataAndGeneratePDFBrowserAPI();
    // let { searchValue} = {};
    let noValExistTextNA = <p className="fst-italic light-clrs text">N/A</p>;
    let noValExistText = <p className="fst-italic light-clrs text">No data recorded</p>;
    console.log("DataPatientDataHeaderDetails", data)

    const isVisuallyEmpty = (html = '') => {
        return html.replace(/<[^>]*>/g, '').trim() === '';
    }

  return (
        <Modal show={printoutModal} onHide={printoutModal} backdrop="static" keyboard={false} centered dialogClassName="ar_encounter_print_modal ar_encounter_main_screen ar_encounter_preview_sceen p-0 hk-modal-v1 table-default-design bg-transparent" >
            {isLoadingPdf && <Loader />}
            <Modal.Body className='hover-scrollbar'>
                <div className="d-flex align-items-center justify-content-center gap-2 pt-15 ar_print-header pb-2">
                    <span class="icon-Group-1000002858 fs-20" onClick={() => captureDataAndGeneratePDF(componentRef, `${data?.Patient || 'SOAP'}.pdf`, 'highRes')}>
                        <span class="path1"></span><span class="path2"></span>
                    </span>
                    <i className="icon-Icon-metro-cross fs-20" onClick={() => setPrintoutModal(false)}></i>
                </div>
                <div ref={componentRef}>
                    <div className={`px-10 pb-15 pt-2 ar_native_pdf_design encounter-notes-design ${selectedItems?.["uiDesign"] ? 'Black-in-White-Design' : ''}`}>
                        <div className='d-flex flex-column gap-10 mb-15'>
                            <div className="d-flex align-items-center justify-content-center gap-12 pat-det-header">
                                <div className="d-flex align-items-center gap-1">
                                    <p className='heading text-white'>{data?.Patient}</p>
                                    <p className='text text-white'>{data?.DOB}</p>
                                    <p className='text text-white'>{data?.Age ? `(${data?.Age})` : ''}</p>
                                    <p className='text text-white'>{data?.Gender}</p>
                                </div>
                                <div className="text light-clrs">|</div>
                                <div className="d-flex align-items-center gap-1">
                                    <p className='text font-m text-white'>Account #</p>
                                    <p className="text text-white">{data?.AccountNumber || noValExistTextNA}</p>
                                </div>
                                {/* <div className="text light-clrs">|</div>
                                <div className="d-flex align-items-center gap-1">
                                    <p className='text font-m text-white'>DOS:</p>
                                    <p className="text text-white">{searchParam?.EncounterDate || noValExistTextNA}</p>
                                </div> */}
                            </div>
                            <div className="d-flex align-items-center justify-content-between">
                                {console.log("dataqwertDataTherapyNote", data)}
                                <PracticeDetailsPrintPopup data={data} />
                            </div>
                            <div className=''>
                                <div className="encounter-edit-mode-pdf p-2 d-flex flex-column gap-1">
                                    <div className="col-md-12 p-0 d-flex gap-1">
                                        <p className="heading validate-color fs-16 lh-15">{data?.Patient}</p>
                                        <span className='d-flex gap-1 align-items-center'>
                                            <span className='text text-black'>{data?.DOB}</span> <span className='text text-black'>{data?.Age ? `(${data?.Age})` : ''}</span> <span className='text text-black'>{data?.Gender}</span>
                                        </span>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex flex-column gap-1">
                                            <div className="d-flex align-items-center gap-1">
                                                <p className="text font-m w-72px text-black">Account #</p>
                                                <p className="text text-black">{data?.AccountNumber || noValExistTextNA}</p>
                                            </div>
                                            <div className="d-flex align-items-center gap-1">
                                                <p className="text font-m w-72px text-black">Phone:</p>
                                                <p className="text text-black">{data?.['Phone#'] ? FormatPhoneNumber(data?.['Phone#']) : noValExistTextNA}</p>
                                            </div>
                                            <div className="d-flex align-items-center gap-1">
                                                <p className="text font-m w-72px text-black">Address:</p>
                                                <p className="text text-black">
                                                    {data?.Address || noValExistTextNA}
                                                </p>
                                            </div>
                                        </div>

                                        <div className="d-flex flex-column gap-1">
                                            <div className="d-flex align-items-center gap-1">
                                                <p className="text font-m w-72px text-black">Provider:</p>
                                                <p className="heading validate-color">{data?.Provider || noValExistTextNA}</p>
                                            </div>
                                            <div className="d-flex align-items-center gap-1">
                                                <p className="text font-m w-72px text-black">Insurance:</p>
                                                <p className="text text-black">{data?.Insurance || noValExistTextNA}</p>
                                            </div>
                                            <div className="d-flex align-items-center gap-1">
                                                <p className="text font-m w-72px text-black">Location:</p>
                                                <p className="text text-black">{data?.LocationName || noValExistTextNA}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center gap-1">
                                    <p className='heading validate-color'>Last Updated:</p>
                                    <p className='text validate-color'>{data?.LastUpdated || noValExistTextNA}</p>
                                </div>

                                <div className="d-flex align-items-center gap-2">
                                    {/* <div className="d-flex align-items-center gap-1">
                                        <p className="heading validate-color">Encounter Type:</p>
                                        {searchValue?.EncounterType ?
                                            <span className="text validate-color">{searchValue.EncounterType}</span>
                                            :
                                            <>{noValExistTextNA}</>}
                                    </div> */}

                                    <div className="d-flex align-items-center gap-1">
                                        <p className="heading validate-color">Note Type:</p>
                                        <span className="text validate-color">Psychotherapy Note</span>
                                        {/* {searchValue?.NoteType ?
                                            <span className="text validate-color">{searchValue.NoteType}</span>
                                            :
                                            <>{noValExistTextNA}</>} */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    <div className="d-flex flex-column gap-6">
                        <div className="d-flex align-items-center justify-content-between">
                            <p class="text fs-14 font-b validate-color blue-bg">PSYCHOTHERAPY NOTE</p>
                        </div>
                        <div>
                            {isVisuallyEmpty(data?.PsychotherapyNotes) ?
                                noValExistText :
                                <p className="text text-black" dangerouslySetInnerHTML={{ __html: data?.PsychotherapyNotes }}></p>}
                        </div>
                    </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
  )
}

export default PrintPreviewTherapyNote